module.exports = __webpack_public_path__ + "img/nature-22.dcec7e01.jpg";